import { useContext } from 'react'

import HeaderButtonsContainerContext from '@contexts/headerSearchBar'

const useHeaderSearchBar = () => useContext(HeaderButtonsContainerContext)

export default useHeaderSearchBar
